import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useFormatNumber = () => {
  const { i18n } = useTranslation()
  const currentLocale = i18n.resolvedLanguage || i18n.language

  return useCallback(
    (value: number | null | undefined, fallback = '--', options?: Intl.NumberFormatOptions) => {
      if (typeof value !== 'number' || !Number.isFinite(value)) {
        return fallback
      }

      return new Intl.NumberFormat(currentLocale, options).format(value)
    },
    [currentLocale]
  )
}
